import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ValidationErrorMessages } from '@bazis/form/models/form-element.types';
import { BazisConfigurationService } from '@bazis/configuration.service';
@UntilDestroy()
@Component({
    selector: 'bazis-display-error',
    templateUrl: './display-error.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisDisplayErrorComponent {
    @HostBinding('class') get hostStyle() {
        return {
            'bazis-display-error': true,
            [`bazis-display-error_icon`]: this.hasIcon,
        };
    }

    @Input()
    errorKey;

    @Input()
    errorParams;

    @Input()
    error;

    @Input()
    validationErrorMessages: ValidationErrorMessages;

    @Input()
    hasIcon = false;

    icons;

    constructor(private configurationService: BazisConfigurationService) {
        this.icons = this.configurationService.controlIcons;
    }
}
